import React from "react";
import { useTranslation } from "react-i18next";
import "./BanderaContacto.css";
import { Sede } from "../types";

export default function BanderaContacto() {
  const { t } = useTranslation();

  const sedes: Sede[] = [
    { id: "argentina", img: "/argentina.webp" },
    { id: "espana", img: "/espana.webp" },
    { id: "chile", img: "/chile.webp" },
  ];

  return (
    <section className="bandera-contacto-seccion">
      <div className="empresa-banderas-contacto">
        {sedes.map((sede) => (
          <div className="bandera-contacto-item" key={sede.id}>
            <img src={sede.img} alt={t(`sedes.${sede.id}.pais`) || sede.id} />
            <p style={{ whiteSpace: "pre-line" } as React.CSSProperties}>
              <strong>{t(`sedes.${sede.id}.pais`)}</strong>
              {"\n"}
              {t(`sedes.${sede.id}.direccion`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
